import { httpService } from '../../../../../../../../../services/http.service';
import bugsnagHandler from '../../../../../../../../../services/bugsnag.service';
import { BASE_URL } from '../../../../../../../../../constants/endpoints';

export const markBillAsUnpaidAPIAction = async (customerId: string, accountExternalId: string, billId: string) => {
  if (!customerId || !accountExternalId || !billId) {
    bugsnagHandler.notify('Bill Pay - Bills Hub - Mark Bill as Unpaid Action - Missing customerId, accountExternalId or billId');
    return false;
  }
  try {
    const { data } = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/bill/${billId}/markAsUnpaid`);
    return data;
  } catch (e: any) {
    bugsnagHandler.notify('Bill Pay - Bills Hub - Mark Bill as Unpaid Action - error marking bill as unpaid', e);
    throw e;
  }
};
